// extracted by mini-css-extract-plugin
export default {"loaderContainer":"styles_loaderContainer__1GOoD"};